import documentTypeList, {
  DocumentTypeListParams
} from "@/getinfo-api/documentType";
import { TermList as ITermList } from "@/api/models/term-list";
import { Term as ITerm } from "@/api/models/term";
import { TermEdit as ITermEdit } from "@/api/models/term-edit";
import { uniqBy } from "lodash";
import api from "@/getinfo-api";

export default {
  namespaced: true,
  state: {
    termList: [] as Array<ITerm>,
    count: 0,
    offset: 0,
    limit: 30
  },
  actions: {
    async LIST(ctx: any, params: DocumentTypeListParams) {
      let _params: DocumentTypeListParams = {
        ...params,
        offset: ctx.state.offset,
        limit: ctx.state.limit
      };
      try {
        let response = await documentTypeList(_params);
        ctx.commit("ADD_TO_LIST", response.data);
        ctx.commit("INCREASE_OFFSET");
      } catch (e) {
        await ctx.dispatch(
          "errorException",
          {
            vm: this,
            error: e.response
          },
          { root: true }
        );
      }
    },
    async DELETE_TERM(ctx: any, termId: string) {
      try {
        await api.DocumentTypeTaxonomyApi._delete(termId);
        ctx.commit("REMOVE_TERM_FROM_LIST", termId);
        ctx.commit("DECREASE_OFFSET");
        ctx.commit("DECREASE_COUNT");
      } catch (e) {
        await ctx.dispatch(
          "errorException",
          {
            vm: this,
            error: e.response
          },
          { root: true }
        );
      }
    },
    async EDIT_TERM(ctx: any, payload: { id: string; term: ITermEdit }) {
      try {
        await api.DocumentTypeTaxonomyApi.edit(payload.id, payload.term);
      } catch (e) {
        await ctx.dispatch(
          "errorException",
          {
            vm: this,
            error: e.response
          },
          { root: true }
        );
      }
    }
  },
  mutations: {
    REMOVE_TERM_FROM_LIST(state: any, termId: string) {
      state.termList = state.termList.filter((el: ITerm) => el.id !== termId);
    },
    ADD_TO_LIST(state: any, termList: ITermList) {
      state.termList = [...termList.items, ...state.termList];
      state.termList = uniqBy(state.termList, "id");
      state.count = termList.count;
    },
    CLEAR(state: any) {
      state.termList = [];
      state.count = 0;
      state.offset = 0;
    },
    INCREASE_OFFSET(state: any) {
      state.offset += state.limit;
    },
    DECREASE_OFFSET(state: any) {
      state.offset--;
    },
    DECREASE_COUNT(state: any) {
      state.count--;
    }
  },
  getters: {
    GET_TERMS(state: any) {
      return state.termList;
    },
    GET_TERMS_COUNT(state: any) {
      return state.count;
    }
  }
};
